<div class="login-wrapper">
	<div class="backdrop-wrapper d-flex align-items-center justify-content-center">
		<div class="login-container">
			<div *ngIf="appContext.isSunip">
				<img src="{{appContext.fullLogoColor}}" style="height: 100px" title="SunIP"/>
			</div>
			<div *ngIf="appContext.isForecaster">
				<img src="{{appContext.fullLogoColor}}" style="height: 100px" title="ChiefIP"/>
			</div>
			<div *ngIf="appContext.isLegalsight">
				<img src="{{appContext.fullLogoColor}}" style="height: 70px" title="LegalSight"/>
			</div>
			
			<townip-standard-alert iconAlignment="top" class="mt-4" type="success" mode="lite">
				<div>You have successfully activated Multi-Factor authentication</div>
			</townip-standard-alert>
			
			<button routerLink="/auth/logout" class="btn btn-primary btn-lg mt-4">Login</button>
		
		</div>
	</div>
</div>
